import { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const SKELETON_ROWS = ['a', 'b', 'c', 'd'];

export function LedgerSkeleton() {
  return (
    <div className="space-y-2">
      {SKELETON_ROWS.map((row) => (
        <Skeleton key={row} className="h-14 w-full rounded-lg" />
      ))}
    </div>
  );
}

export function LedgerEmpty({ children }: { children: ReactNode }) {
  return (
    <p className="rounded-lg border border-dashed px-4 py-8 text-center text-sm text-muted-foreground">
      {children}
    </p>
  );
}
